export default __webpack_public_path__ + "static/media/Sem Conexão.c1b7cd07.svg";